<div
    *ngIf="label !== undefined"
    [class.small-font]="smallFont"
    [class]="getLabelsBadgeColor(label)">
    {{ label }}
</div>
